import { EntregaPorBairroRequest } from "./bairro.model";
import { Computadores } from "./computadores.model";

export class ConfiguracaoModel {
    aliqCofins: number;
    aliqPIS: number;
    cobrarTaxaServico: boolean;
    codIncTrib: number;
    codTipContrib: number;
    codTipoAcaoPosVenda: number;
    codigo: number;
    dataUltimoEnvioFechamentoFiscal: string;
    empresaEmitenteIndustria: boolean;
    exibirOutrasDespesasEmTelaPgto: boolean;
    exibirProdComEstoqueMaiorQueZero: boolean;
    imprimirComprovanteVendaPrazo: boolean;
    imprimirCupomValeTroca: boolean;
    indAproCred: number;
    indRegCumu: number;
    lasanhaPorMaiorValor: boolean;
    mesclarObservacoesDoProdutoNFeNoNome: boolean;
    pizzaPorMaiorValor: boolean;
    solicitarCpfNFCE: boolean;
    tipoSistema: string;
    ultimoNsuNFe: number;
    utilizaTEF: any;
    valorCouvertArtistico: number;
    versaoCodigo: number;
    versaoDesktop: string;
    versaoMobile: any;
    jsonOutrasConfig: string;
}

export class ConfigPdvDeliveryResponse {
    public configIntegracao: ConfigPedidoResponse[] = [];
    public removerCabecalho: boolean = false;
    public imprimirComposicaoProduto: boolean = false;
    public imprimirPedidoBalcaoCompleto: boolean = false;
    public imprimirSegundaViaDeliveryRecepcao: boolean = false;
    // public unicoImprimirPrecontasCelular: boolean = false;
    public computadores: Computadores[] = [];
    public cobrarTaxaServico: boolean = false;
    public taxasEntrega: EntregaPorBairroRequest[] = [];
}

export class ConfigPdvDeliveryRequest {
    public configIntegracao: ConfigPedidoRequest[] = [];
    public removerCabecalho: boolean = false;
    public imprimirComposicaoProduto: boolean = false;
    public imprimirPedidoBalcaoCompleto: boolean = false;
    public imprimirSegundaViaDeliveryRecepcao: boolean = false;
    public unicoImprimirPrecontasCelular: boolean = false;
    public cobrarTaxaServico: boolean = false;
    public computadores: [] = [];
    public taxasEntrega: EntregaPorBairroRequest[] = [];
    public sistema: string = "pdv-web";
}

export class ConfigPedidoRequest {
    public removerCabecalho: boolean = false;
    public imprimirComposicaoProduto: boolean = false;
    public imprimirPedidoBalcaoCompleto: boolean = false;
    public imprimirSegundaViaDeliveryRecepcao: boolean = false;
    public unicoImprimirPrecontasCelular: boolean = false;
    public cobrarTaxaServico: boolean = false;
    public aceitarTodosPedidosAuto: boolean = true;
    public valorMinimoPedido: number = 0;
    public codigoPessoaIntegracao: number = 0;
    public horaAbertura: string = '';
    public horaFechamento: string = '';
}

export class ConfigPedidoResponse {
    public removerCabecalho: boolean = false;
    public imprimirComposicaoProduto: boolean = false;
    public imprimirPedidoBalcaoCompleto: boolean = false;
    public imprimirSegundaViaDeliveryRecepcao: boolean = false;
    public unicoImprimirPrecontasCelular: boolean = false;
    public cobrarTaxaServico: boolean = false;
    public aceitarTodosPedidosAuto: boolean = true;
    public valorMinimoPedido: number = 0;
    public codigoPessoaIntegracao: number = 0;
    public horaAbertura: string = '';
    public horaFechamento: string = '';
}

export class ConfigPedidoViewModel {
    public removerCabecalho: boolean = false;
    public imprimirComposicaoProduto: boolean = false;
    public imprimirPedidoBalcaoCompleto: boolean = false;
    public imprimirSegundaViaDeliveryRecepcao: boolean = false;
    public unicoImprimirPrecontasCelular: boolean = false;
    public cobrarTaxaServico: boolean = false;
    public aceitarTodosPedidosAuto: boolean = false;
    public valorMinimoPedido: number = 0;
    public codigoPessoaIntegracao: number = 0;
    public horaAbertura: string = '';
    public horaFechamento: string = '';
    // private _horaAbertura: string = '';
    // private _horaFechamento: string = '';

    // public override get horaAbertura(): string {
    //   return this._horaAbertura;
    // }

    // public override set horaAbertura(horario: string) {
    //   const regex = /^([01]\d|2[0-3]):([0-5]\d)$/;
    //   if (!regex.test(horario)) {
    //     throw new Error('Horário inválido. Utilize o formato "HH:mm".');
    //   }

    //   this._horaAbertura = horario;
    // }

    // public override get horaFechamento(): string {
    //   return this._horaFechamento;
    // }

    // public override set horaFechamento(horario: string) {
    //   const regex = /^([01]\d|2[0-3]):([0-5]\d)$/;
    //   if (!regex.test(horario)) {
    //     throw new Error('Horário inválido. Utilize o formato "HH:mm".');
    //   }

    //   this._horaFechamento = horario;
    // }
}

export class ConfiguracaoPedido {
    aceitarPedidosAutomaticamente: boolean = false;
    valorMinimoPedido: number = 0;
    private _horarioFuncionamentoAbertura: string = '';
    private _horarioFuncionamentoFechamento: string = '';

    public get horarioFuncionamentoAbertura(): string {
        return this._horarioFuncionamentoAbertura;
    }

    public set horarioFuncionamentoAbertura(horario: string) {
        const regex = /^([01]\d|2[0-3]):([0-5]\d)$/;
        if (!regex.test(horario)) {
            throw new Error('Horário inválido. Utilize o formato "HH:mm".');
        }

        this._horarioFuncionamentoAbertura = horario;
    }

    public get horarioFuncionamentoFechamento(): string {
        return this._horarioFuncionamentoFechamento;
    }

    public set horarioFuncionamentoFechamento(horario: string) {
        const regex = /^([01]\d|2[0-3]):([0-5]\d)$/;
        if (!regex.test(horario)) {
            throw new Error('Horário inválido. Utilize o formato "HH:mm".');
        }

        this._horarioFuncionamentoFechamento = horario;
    }
}